import React from 'react';
import ByMeByAllFilter from '../by_me_by_all_filter';

interface ByMeByAllGroupProps {
  byMe: boolean;
  byAll: boolean;
  search: string | null;
  setSearch: React.Dispatch<React.SetStateAction<string | null>>;
  handle: () => void;
}

const ByMeByAllGroup = ({ byMe, byAll, handle, search, setSearch }: ByMeByAllGroupProps) => {
  return (
    <div className="d-flex mb-2 px-3" role="group" aria-label="Monitorar opções">
      <ByMeByAllFilter source="chat" byMe={byMe} byAll={byAll} handle={handle} />
      <input
        id="search"
        name="search"
        className="form-control ml-2"
        value={search || ''}
        onChange={(e) => setSearch(e.target.value)}
        type="text"
        placeholder="Edital ou Nº Conlicitação"
      />
    </div>
  );
};

export default ByMeByAllGroup;
